
export type NationalDateFormat = {
    format: string[],
    placeholders: string[],
    separators: string[],
    string: string,
    readonly?: boolean[],
    numeric?: boolean[],
}

/**
 * Date formats for cawi.
 */
export default class DateFormats {
    private static readonly NATIONAL_DATE_FORMATS = {
        'DMYdot': { // czech
            format: ['DD', 'MM', 'YYYY'],
            placeholders: ['DD', 'MM', 'YYYY'],
            separators: ['.', '.'],
            string: 'DD.MM.YYYY'
        },
        'DMYslash': { // british
            format: ['DD', 'MM', 'YYYY'],
            placeholders: ['DD', 'MM', 'YYYY'],
            separators: ['/', '/'],
            string: 'DD/MM/YYYY'
        },
        'MDYslash': { // american
            format: ['MM', 'DD', 'YYYY'],
            placeholders: ['MM', 'DD', 'YYYY'],
            separators: ['/', '/'],
            string: 'MM/DD/YYYY'
        },
        'YMDdot': { // hungarian
            format: ['YYYY', 'MM', 'DD'],
            placeholders: ['YYYY', 'MM', 'DD'],
            separators: ['.', '.'],
            string: 'YYYY.MM.DD'
        },
        'DMYhyphen': { // netherlands
            format: ['DD', 'MM', 'YYYY'],
            placeholders: ['DD', 'MM', 'YYYY'],
            separators: ['-', '-'],
            string: 'DD-MM-YYYY'
        },

        'japan': {
            format: ['DD', 'MM', 'YYYY'],
            placeholders: ['DD', 'MM', 'YYYY'],
            separators: ['年', '月', '日'],
            string: 'DD年MM月YYYY日'
        },
    };

    public static date(country?: string): NationalDateFormat {
        if (!country) {
            return this.NATIONAL_DATE_FORMATS.DMYdot;
        }

        country = country.toLowerCase().substr(0, 2);

        if ((['en', 'es', 'fr', 'it', 'pt', 'th',]).indexOf(country) !== -1) {
            return this.NATIONAL_DATE_FORMATS.DMYslash;
        }
        if ((['us']).indexOf(country) !== -1) {
            return this.NATIONAL_DATE_FORMATS.MDYslash;
        }
        if ((['hu']).indexOf(country) !== -1) {
            return this.NATIONAL_DATE_FORMATS.YMDdot;
        }
        if ((['ja']).indexOf(country) !== -1) {
            return this.NATIONAL_DATE_FORMATS.japan;
        }
        if ((['nl', 'sv']).indexOf(country) !== -1) {
            return this.NATIONAL_DATE_FORMATS.DMYhyphen;
        }
        return this.NATIONAL_DATE_FORMATS.DMYdot;
    }

    public static time(country?: string): NationalDateFormat {

        // English speaking countries, China, and north of Africa use 12 hours format
        // https://en.wikipedia.org/wiki/Date_and_time_representation_by_country
        if (country && (['en', 'zh']).indexOf(country) !== -1) {
            return {
                format: ['hh', 'mm', 'A'],
                placeholders: ['hh', 'mm', ''],
                separators: [':', ''],
                string: 'hh:mm',
                readonly: [false, false, false],
                numeric: [true, true, false]
            }
        }
        return {
            format: ['HH', 'mm'],
            placeholders: ['hh', 'mm'],
            separators: [':'],
            string: 'hh:mm'
        }
    }
}

